import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  GetClassOfActivityFilterValues,
  GetLocalAuthorityFilterValues,
  GetStatusFilterValues,
  GetWasteCategoryFilterValues,
  ICertificateOfRegistrationClassesOfActivityList,
  ICertificateOfRegistrationLocalAuthoritiesList,
  ICertificateOfRegistrationStatusesList,
  ICertificateOfRegistrationWasteCategoriesList,
} from "../../../../api/CircularEconomy/CertificateOfRegistration/ICertificateOfRegistration";
import { RootState } from "../../../../redux/store";

export interface CertificateOfRegistrationListState {
  fetchStatus: string;
  error: any;
  statusFilterValues: ICertificateOfRegistrationStatusesList;
  localAuthorityFilterValues: ICertificateOfRegistrationLocalAuthoritiesList;
  wasteCategoryFilterValues: ICertificateOfRegistrationWasteCategoriesList;
  classOfActivityFilterValues: ICertificateOfRegistrationClassesOfActivityList;
}

const initialState: CertificateOfRegistrationListState = {
  error: undefined,
  fetchStatus: "Loading...",
  statusFilterValues: { count: 0, list: [], length: 0, page: 1 },
  localAuthorityFilterValues: { count: 0, list: [], length: 0, page: 1 },
  wasteCategoryFilterValues: { count: 0, list: [], length: 0, page: 1 },
  classOfActivityFilterValues: { count: 0, list: [], length: 0, page: 1 },
};

export const loadCertificateOfRegistrationFilterValuesAsync = createAsyncThunk(
  "certificateOfRegistrationFilterValues/load",
  async () => {
    let statusFilterValues = await GetStatusFilterValues();
    let localAuthorityFilterValues = await GetLocalAuthorityFilterValues();
    let wasteCategoryFilterValues = await GetWasteCategoryFilterValues();
    let classOfActivityFilterValues = await GetClassOfActivityFilterValues();

    // The value we return becomes the `fulfilled` action payload
    return {
      statusFilterValues: statusFilterValues,
      localAuthorityFilterValues: localAuthorityFilterValues,
      wasteCategoryFilterValues: wasteCategoryFilterValues,
      classOfActivityFilterValues: classOfActivityFilterValues,
    };
  }
);

export const certificateOfRegistrationFilterValuesSlice = createSlice({
  name: "certificateOfRegistrationFilterValues",
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {},
  // The `extraReducers` field lets the slice handle actions defined elsewhere,
  // including actions generated by createAsyncThunk or in other slices.
  extraReducers: (builder) => {
    builder
      .addCase(
        loadCertificateOfRegistrationFilterValuesAsync.pending,
        (state) => {
          state.fetchStatus = "loading";
        }
      )
      .addCase(
        loadCertificateOfRegistrationFilterValuesAsync.fulfilled,
        (state, action) => {
          state.fetchStatus = "idle";
          state.statusFilterValues = action.payload.statusFilterValues;
          state.localAuthorityFilterValues =
            action.payload.localAuthorityFilterValues;
          state.wasteCategoryFilterValues =
            action.payload.wasteCategoryFilterValues;
          state.classOfActivityFilterValues =
            action.payload.classOfActivityFilterValues;
        }
      )
      .addCase(
        loadCertificateOfRegistrationFilterValuesAsync.rejected,
        (state, action) => {
          state.fetchStatus = "rejected";
          state.error = action.payload;
        }
      );
  },
});

export const selectCertificateOfRegistrationFilterValuesResponse = (
  state: RootState
) => state.certificateOfRegistrationListResponse;

export default certificateOfRegistrationFilterValuesSlice.reducer;
